import { DialogContent } from '../../entities/dialog-content.entity';

export const IesDialog_SignerPage_ChangesInProgress = {
  calloutVariant: 'information',
  headerText: `Your spouse/partner is making changes to the application`,
  confirmButtonText: 'Ok',
  bodyText: `When your spouse/partner has completed the changes, we will let you know so you can review before providing your Consent and Declaration.`,
} as DialogContent;

export const IesDialog_SignerPage_ChangesCompleteOnReturn = {
  calloutVariant: 'information',
  headerText: `Please review again`,
  confirmButtonText: 'Ok',
  bodyText: `Something in the application has changed since your last visit. Please review again.<p>If you're not sure what has changed, ask your spouse/partner so that you can review the updated information.</p>`,
} as DialogContent;

export const IesDialog_SignerPage_ChangesCompleteOnView = {
  calloutVariant: 'information',
  headerText: `Your spouse/partner has finished making changes to the application`,
  confirmButtonText: 'Ok',
  bodyText: `Your screen has refreshed automatically to display the most up-to-date information.<p>If you're not sure what has changed, ask your spouse/partner so that you can review the updated information.</p>`,
} as DialogContent;

export const IesDialog_SignerPage_DeclineVerification = {
  calloutVariant: 'information',
  headerText: 'Decline Consent and Declaration',
  confirmButtonText: 'Skip Consent and Declaration',
  cancelButtonText: 'Back',
  bodyText: `If you choose not to provide Consent and Declaration at this time, your spouse/partner can still submit the application by opting out of your Consent and Declaration. <p>Please note that not providing your Consent and Declaration may cause delays in processing and could result in the withdrawal of the application. A caseworker may follow up with you if needed.</p>`,
} as DialogContent;

export const IesDialog_SignerPage_ConfirmVerification = {
  calloutVariant: 'information',
  headerText: 'Provide your Consent and Declaration',
  confirmButtonText: 'Yes',
  cancelButtonText: 'Cancel',
  bodyText: `Are you sure you want to provide your Consent and Declaration?`,
} as DialogContent;

export const IesDialog_SignaturePage_DeactivateSignatureRequest = {
  calloutVariant: 'important',
  headerText: 'Cancel signature request',
  confirmButtonText: 'Yes',
  cancelButtonText: 'No',
  bodyText: `If you continue, the person you invited will no longer be able to access this application to give their Consent and Declaration. The information you have provided about them will still be submitted as a part of the application.<p><b>Do you want to continue?</b></p>`,
} as DialogContent;

export const IesDialog_SignaturePage_RemoveUploadedForms = {
  calloutVariant: 'important',
  headerText: `Uploaded document will be removed`,
  confirmButtonText: 'Yes',
  cancelButtonText: 'No',
  bodyText: `If you continue, the Consent and Declaration document that you have uploaded will be removed.
    <p><b>Do you want to continue?</b></p>`,
} as DialogContent;

export const IesDialog_Application_UpdateSnapshot = {
  calloutVariant: 'information',
  headerText: `Update sent`,
  okButtonText: 'Ok',
  bodyText: `The changes you made have been shared with your spouse/partner. They already have access from the invite you sent before, so you do not need to do anything else right now. 
  <p>Your spouse/partner needs to review the updated information and provide their Consent and Declaration before you can submit the application.</p>`,
} as DialogContent;

export const IesDialog_MySituation_MaritalStatusChange = {
  calloutVariant: 'important',
  headerText: `Your spouse/partner's access will be removed`,
  confirmButtonText: 'Yes',
  cancelButtonText: 'No',
  bodyText: `If you continue:
    <ul>
      <li>Your spouse/partner's information will be removed from the application.</li>
      <li>Your spouse/partner will no longer be able to access this application.</li>
    </ul>
    <strong>Do you want to continue?</strong>`,
} as DialogContent;

export const IesDialog_SpousePartner_SpouseLivesWith = {
  calloutVariant: 'important',
  headerText: `Your spouse/partner's access will be removed`,
  confirmButtonText: 'Yes',
  cancelButtonText: 'No',
  bodyText: `If you change your answer to this question, your spouse/partner's Consent and Declaration will no longer be required and the invite will be revoked. 
  <p>Do you want to change your answer?</p>`,
} as DialogContent;

export const IesDialog_Application_ConfirmSubmit = {
  calloutVariant: 'information',
  headerText: 'Confirm submission',
  confirmButtonText: 'Yes, submit application',
  cancelButtonText: 'Cancel',
  bodyText: `Are you sure you want to submit this application?`,
} as DialogContent;

export const IesDialog_Application_Locked = {
  calloutVariant: 'information',
  headerText: 'Application is currently locked',
  okButtonText: 'I understand',
  bodyText: `Changes to this application are currently prohibited due to the completion of the spouse digital verification of this application. Your changes could not be saved.`,
} as DialogContent;

export const IesDialog_Dashboard_StartNewApplication = {
  calloutVariant: 'information',
  headerText: 'Start new application?',
  confirmButtonText: 'Continue',
  cancelButtonText: 'Cancel',
  bodyText: `If you are awaiting a decision on your application, do not submit another application. Submitting multiple applications will result in your previous application(s) being withdrawn.`,
} as DialogContent;

export const IesDialog_Dashboard_VerifyAccount = {
  calloutVariant: 'important',
  headerText: 'Verify your Alberta.ca Account',
  confirmButtonText: 'Start verification',
  cancelButtonText: 'Not now',
  bodyText: 'Do you want to start the verification process?',
} as DialogContent;
